import { Button, CountrySelect, Header } from '@components/Generic'
import type { SelectOption } from '@components/Generic/SelectInput/SelectInput'
import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { setUrlParam } from '@/methods/urlParams'

export const CountryPage = observer(() => {
  const store = useContext(StoreContext)
  const { isMobile } = store.AppState
  const { countryPage: trans } = store.TranslationsState.translations

  const [country, setCountry] = useState<SelectOption | null>(null)

  const handleProceed = async () => {
    store.ScenarioState.nextPage()
  }

  const handleCountry = (country: SelectOption | null) => {
    if (country) {
      setCountry(country)
      setUrlParam('selectedCountry', country.value)
    } else {
      setCountry(null)
    }
  }

  return (
    <div className="page-container">
      <Header>{trans.header}</Header>
      <div className="generic__select-holder">
        <CountrySelect
          value={country}
          onChange={(value) => handleCountry(value)}
          showCheckmark
          placeholder={trans.placeholder}
        />
      </div>
      <div className="layout__content-container-bottom-fixed">
        {!isMobile ? <div className="layout__content-container-bottom-left" /> : <></>}
        <Button onClick={() => handleProceed()} disabled={!country}>
          <span className="generic__button-text">{trans.proceed}</span>
        </Button>
      </div>
    </div>
  )
})
